import React from 'react';

/**
 * Read-only display field — shows a labelled gray box.
 *
 * Usage:
 *   <ReadOnlyField label="Client" value={watch('clientName')} />
 *
 *   // With empty state placeholder:
 *   <ReadOnlyField label="Notes from Franchisee" value={notes}
 *     emptyText="No notes provided." minHeight />
 */
export function ReadOnlyField({
  label,
  value,
  emptyText,         // shown when value is falsy
  minHeight = false, // adds min-h-[2.5rem] for multi-line empty states
  hint,              // small text shown below (e.g. address line)
  labelClassName = '',
  wrapperClassName = '',
}) {
  return (
    <div className={wrapperClassName}>
      {label && (
        <label className={`block text-sm font-medium text-gray-700 mb-1 ${labelClassName}`}>
          {label}
        </label>
      )}
      <div
        className={[
          'p-2 bg-gray-100 border border-gray-300 rounded-xl text-sm text-gray-700',
          minHeight ? 'min-h-[2.5rem]' : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {value || (emptyText ? <span className="text-gray-400">{emptyText}</span> : null)}
      </div>
      {hint && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
    </div>
  );
}
